import { SECTION_NAV_ALL_SECTIONS_LABEL, useSectionNavLinks } from "@/pages/sections/[sectionId]/_utils";
import MobileNavigation from "./MobileNavigation";

export interface MobileSectionNavigationProps {
  sectionId: string;
}

export default function MobileSectionNavigation({ sectionId }: MobileSectionNavigationProps) {
  const allNavLinks = useSectionNavLinks(sectionId);

  const navLinks = {
    ...allNavLinks,
    "Manage Section": (allNavLinks["Manage Section"] || []).filter(
      (link) => link.label !== SECTION_NAV_ALL_SECTIONS_LABEL
    )
  };

  return <MobileNavigation links={navLinks} section="Manage Section" testId="mobile-section-navigation" />;
}
